/**
 *
 * @param {PropertyValueProps} initial
 * @param {Array<String | Array<String>>} array
 * @returns {String}
 */
const getJoinedFnArray = (initial, array) => {
  const joined = [];
  const numElements = array[0].length;
  const fn = initial.get("v_name");
  const initials = /** @type {Array<Map<String, any>>} */ (
    initial.get("v_values")
  );
  const divider = initial.get("v_is-calc") ? initial.get("v_divider") : ",";

  for (let i = 0; i < numElements; i++) {
    const combined = [];
    const output = initials[i].get("v_output");

    for (const item of array) {
      combined.push(item[i]);
    }

    joined.push(`calc(${output} - ${combined.join(" - ")})`);
  }

  return `${fn}(${joined.join(divider)})`;
};

export default getJoinedFnArray;
